import { CreateResourceUserRequest, DeleteResourceUserRequest, ResourceUserDto, ResourceUsersClient } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { queryClient } from "@hooks/useGlobalState";
import { useMutation, useQuery } from "@tanstack/react-query";
const resourceUserClient = new ResourceUsersClient(undefined, axios);

export const useGetResourceUsers = (projectId: string, isFromApsUser: boolean, options?: any) => {
  return useQuery<ResourceUserDto[]>({
    ...options,
    queryKey: ["resourceUser", projectId, isFromApsUser],
    queryFn: async () => resourceUserClient.getResourceUsers(projectId, isFromApsUser),
    placeholderData: [],
    staleTime: 30 * 60 * 1000, // 30 minutes
    cacheTime: 60 * 60 * 1000, // 60 minutes      
  });
};

export const useCreateResourceUser = (options?: any) => {
  return useMutation<void>({
    ...options,
    mutationFn: (resourceUser: CreateResourceUserRequest) => resourceUserClient.createResourceUser(resourceUser),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["resourceUser"], exact: false });
      options?.onSuccess?.();
    },
  });
};

export const useDeleteResourceUser = (options?: any) => {
  return useMutation<void>({
    ...options,
    mutationFn: (deleteRequest: DeleteResourceUserRequest) => resourceUserClient.deleteResourceUser(deleteRequest),
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ["resourceUser"], exact: false });
      options?.onSuccess?.();
    },
  });
};
